/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Injectable } from '@angular/core';
import { TranslationService } from '@gh/core-mls';
import { ManualGridDefinition } from '@gh/core-ui-grid';
import { ColDef, GridOptions } from 'ag-grid-community';

@Injectable()
export class ExportPricesGridDefinition extends ManualGridDefinition {
  constructor(private translationService: TranslationService) {
    super();
  }

  buildColumnDefs(): ColDef[] {
    return [
      {
        field:      'code',
        headerName: this.translationService.get('lbl_code'),
        width:      250,
      },
      {
        field:      'cost',
        headerName: this.translationService.get('lbl_current_price'),
        width:      250,
      },
      {
        field:      'name',
        headerName: this.translationService.get('lbl_description'),
        width:      250,
      },
      {
        field:      'uomCode',
        headerName: this.translationService.get('lbl_uom_abbreviation'),
        width:      250,
      },
      {
        field:      'memo',
        headerName: this.translationService.get('lbl_memo'),
        width:      550,
      },
      ];
  }

  buildGridOptions(): GridOptions {
    return { getRowId: (params) => String(params.data.id)};
  }
}
